/**
 * WD Contact form: Israeli phone + client-side checks (Shopify contact still validates server-side).
 *
 * Phone: strip non-digits, normalize +972… to 0-local, then enforce Israeli shapes:
 *   • 9-digit geographic 02/03/04/08/09 (0[23489] + 7 digits)
 *   • 10-digit mobile 05 + 8 digits (all 050–059, not the older narrow third-digit set)
 *   • 10-digit VoIP / virtual 07 + 8 digits
 * Rejects all-same-digit strings. Optional data-phone-pattern must also match (merchant override).
 *
 * Also validates: contact[name] (letters + space/hyphen/apostrophe; no digits; ≥1 letter),
 * contact[email], contact[מחלקה], contact[body], contact[אישור תנאים]
 * (terms), and disallows C0 control characters in text fields. Shopify still validates server-side.
 */
(function () {
  /** FAQ modal: merge from dialog `template`/`script` if present (backup); primary strings from `snippets/wd-contact-form-strings-window.liquid`. */
  function mergeWdContactFormStringsFromFaqDialog(form) {
    var dialog = form.closest('dialog.wd-faq__contact-dialog') || form.closest('[data-wd-faq-contact-dialog]');
    if (!dialog) return;
    var raw =
      dialog.querySelector('template[data-wd-cf-strings]') ||
      dialog.querySelector('script[type="application/json"][data-wd-cf-strings]');
    if (!raw) return;
    var text =
      raw.tagName === 'TEMPLATE'
        ? String(raw.innerHTML || raw.textContent || '').trim()
        : String(raw.textContent || '').trim();
    if (!text) return;
    try {
      var parsed = JSON.parse(text);
      if (typeof parsed !== 'object' || parsed === null) return;
      window.wdContactFormStrings = Object.assign({}, window.wdContactFormStrings || {}, parsed);
    } catch (e) {
      /* ignore */
    }
  }

  function t(key) {
    var bag = window.wdContactFormStrings;
    if (typeof bag === 'object' && bag !== null && Object.prototype.hasOwnProperty.call(bag, key) && bag[key] != null) {
      var s = String(bag[key]);
      if (s.length) return s;
    }
    return key;
  }

  function digitsOnly(s) {
    return String(s || '').replace(/\D/g, '');
  }

  /** +972… or 972… → leading 0 local (Israel drops trunk 0 in international format). */
  function normalizeIsraeliPhoneDigits(raw) {
    var d = digitsOnly(raw);
    if (!d) return '';
    if (d.charAt(0) === '0') return d;
    if (d.indexOf('972') === 0) {
      var rest = d.slice(3);
      if (!rest) return d;
      if (rest.charAt(0) === '0') rest = rest.slice(1);
      return '0' + rest;
    }
    return d;
  }

  function isAllSameDigit(d) {
    return d.length > 0 && /^(\d)\1+$/.test(d);
  }

  /** C0 / DEL control characters that should not be posted in text fields. */
  function hasIllegalControlChars(s) {
    return /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/.test(s);
  }

  /** Pragmatic single-@ email shape (use with input type=email checkValidity). */
  function isReasonableEmailShape(s) {
    if (!s || s.length < 5 || s.length > 254) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s);
  }

  /**
   * Full name: letters (any script) + combining marks, spaces, hyphen / Hebrew maqaf, apostrophe / geresh.
   * No digits; no other punctuation; at least one letter (not "-" or "׳" alone).
   * @returns {'digits'|'badchar'|'noletter'|null}
   */
  function contactNameValidationIssue(trimmed) {
    if (!trimmed) return null;
    if (/\p{Nd}/u.test(trimmed)) return 'digits';
    if (!/^[\p{L}\p{M}\s\-'\u2019\u05F3\u05BE]+$/u.test(trimmed)) return 'badchar';
    if (!/\p{L}/u.test(trimmed)) return 'noletter';
    return null;
  }

  function wireNameFieldGuards(form) {
    var nameEl = form.querySelector('[data-wd-rule="name"]');
    if (!nameEl || nameEl.getAttribute('data-wd-name-guard') === '1') return;
    nameEl.setAttribute('data-wd-name-guard', '1');
    nameEl.addEventListener('beforeinput', function (ev) {
      if (!ev || typeof ev.inputType !== 'string' || ev.inputType.indexOf('insert') !== 0) return;
      if (ev.data == null || ev.data === '') return;
      if (ev.data.length === 1 && /\p{Nd}/u.test(ev.data)) {
        ev.preventDefault();
      }
    });
    nameEl.addEventListener('input', function () {
      var v = nameEl.value;
      var next = v.replace(/\p{Nd}/gu, '');
      if (next !== v) {
        nameEl.value = next;
      }
    });
  }

  /** Digits only — block -, /, spaces, and other separators while typing/pasting. */
  function wirePhoneFieldGuards(form) {
    var phoneEl = form.querySelector('[data-wd-rule="phone"]');
    if (!phoneEl || phoneEl.getAttribute('data-wd-phone-guard') === '1') return;
    phoneEl.setAttribute('data-wd-phone-guard', '1');
    phoneEl.addEventListener('beforeinput', function (ev) {
      if (!ev || typeof ev.inputType !== 'string' || ev.inputType.indexOf('insert') !== 0) return;
      if (ev.data == null || ev.data === '') return;
      if (/\D/.test(ev.data)) {
        ev.preventDefault();
      }
    });
    phoneEl.addEventListener('input', function () {
      var v = phoneEl.value;
      var next = v.replace(/\D/g, '');
      if (next !== v) {
        phoneEl.value = next;
      }
    });
  }

  /** At least one non-disabled <option> with a non-empty value (department routes). */
  function departmentHasSelectableOption(dept) {
    if (!dept || !dept.options) return false;
    for (var i = 0; i < dept.options.length; i++) {
      var o = dept.options[i];
      if (o.disabled) continue;
      if (o.value && String(o.value).trim() !== '') return true;
    }
    return false;
  }

  /** True when d is digits-only, already 0-local, length 9 or 10, and matches a known Israeli block. */
  function isValidIsraeliPhoneStructure(d) {
    if (!d || isAllSameDigit(d)) return false;
    if (d.length === 9) {
      return /^0[23489]\d{7}$/.test(d);
    }
    if (d.length === 10) {
      if (d.indexOf('05') === 0) return /^05\d{8}$/.test(d);
      if (d.indexOf('07') === 0) return /^07\d{8}$/.test(d);
      return false;
    }
    return false;
  }

  function clearErrors(form) {
    form.querySelectorAll('[data-wd-error]').forEach(function (el) {
      el.textContent = '';
      el.classList.add('hidden');
    });
  }

  /** Decode `&amp;#39;`-style entities so error copy from JSON/theme stays readable in text nodes. */
  function decodeHtmlEntities(str) {
    if (typeof str !== 'string' || str.indexOf('&') === -1) return str;
    try {
      var ta = document.createElement('textarea');
      ta.innerHTML = str;
      return ta.value;
    } catch (e) {
      return str;
    }
  }

  function showError(form, rule, message) {
    var el = form.querySelector('[data-wd-error="' + rule + '"]');
    if (!el) return;
    var msg = message == null ? '' : String(message);
    if (msg.indexOf('&') !== -1) msg = decodeHtmlEntities(msg);
    el.textContent = msg;
    el.classList.remove('hidden');
  }

  function focusFirstInvalid(form) {
    var order = ['name', 'phone', 'email', 'department', 'terms', 'comments'];
    for (var i = 0; i < order.length; i++) {
      var err = form.querySelector('[data-wd-error="' + order[i] + '"]');
      if (!err || err.classList.contains('hidden')) continue;
      var inp = form.querySelector('[data-wd-rule="' + order[i] + '"]');
      if (inp) {
        try {
          inp.focus({ preventScroll: false });
        } catch (e2) {
          inp.focus();
        }
        if (typeof inp.scrollIntoView === 'function') {
          inp.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }
      break;
    }
  }

  function validate(form) {
    mergeWdContactFormStringsFromFaqDialog(form);
    clearErrors(form);
    var ok = true;

    var name = form.querySelector('[data-wd-rule="name"]');
    if (name) {
      var nv = (name.value || '').trim();
      if (nv.length < 1) {
        showError(form, 'name', t('err_name'));
        ok = false;
      } else if (hasIllegalControlChars(nv)) {
        showError(form, 'name', t('err_chars'));
        ok = false;
      } else if (nv.length > 500) {
        showError(form, 'name', t('err_name_max'));
        ok = false;
      } else {
        var nameIssue = contactNameValidationIssue(nv);
        if (nameIssue === 'digits') {
          showError(form, 'name', t('err_name_digits'));
          ok = false;
        } else if (nameIssue === 'badchar') {
          showError(form, 'name', t('err_name_invalid_chars'));
          ok = false;
        } else if (nameIssue === 'noletter') {
          showError(form, 'name', t('err_name_no_letters'));
          ok = false;
        }
      }
    }

    var phone = form.querySelector('[data-wd-rule="phone"]');
    if (phone) {
      var raw = phone.value || '';
      if (!String(raw).trim()) {
        showError(form, 'phone', t('err_phone'));
        ok = false;
      } else if (/\D/.test(raw)) {
        /* Reject -, /, spaces, letters, etc. — digits only (do not silently strip on submit). */
        showError(form, 'phone', t('err_phone'));
        ok = false;
      } else if (hasIllegalControlChars(raw)) {
        showError(form, 'phone', t('err_chars'));
        ok = false;
      } else {
        var d = normalizeIsraeliPhoneDigits(raw);
        if (!isValidIsraeliPhoneStructure(d)) {
          showError(form, 'phone', t('err_phone'));
          ok = false;
        } else {
          var patStr = phone.getAttribute('data-phone-pattern');
          if (patStr) {
            try {
              var re = new RegExp(patStr);
              if (!re.test(d)) {
                showError(form, 'phone', t('err_phone'));
                ok = false;
              }
            } catch (e) {
              /* ignore bad pattern from theme settings */
            }
          }
        }
      }
    }

    var email = form.querySelector('[data-wd-rule="email"]');
    if (email) {
      var ev = (email.value || '').trim();
      var emailRequired = email.hasAttribute('required');
      if (!ev) {
        if (emailRequired) {
          showError(form, 'email', t('err_email_required'));
          ok = false;
        }
      } else if (hasIllegalControlChars(ev)) {
        showError(form, 'email', t('err_chars'));
        ok = false;
      } else if (ev.length < 5 || ev.length > 254 || !isReasonableEmailShape(ev) || !email.checkValidity()) {
        showError(form, 'email', t('err_email_invalid'));
        ok = false;
      }
    }

    var dept = form.querySelector('[data-wd-department-select]');
    if (dept) {
      var deptOptMsg = dept.getAttribute('data-wd-err-department-options');
      var deptReqMsg = dept.getAttribute('data-wd-err-department');
      if (!departmentHasSelectableOption(dept)) {
        showError(
          form,
          'department',
          deptOptMsg && String(deptOptMsg).trim() ? deptOptMsg : t('err_department_options')
        );
        ok = false;
      } else if (!dept.value || String(dept.value).trim() === '') {
        showError(form, 'department', deptReqMsg && String(deptReqMsg).trim() ? deptReqMsg : t('err_department'));
        ok = false;
      }
    }

    var terms = form.querySelector('[data-wd-rule="terms"]');
    if (terms && !terms.checked) {
      showError(form, 'terms', t('err_terms'));
      ok = false;
    }

    var comments = form.querySelector('[data-wd-rule="comments"]');
    if (comments) {
      var cv = comments.value || '';
      if (cv && hasIllegalControlChars(cv)) {
        showError(form, 'comments', t('err_chars'));
        ok = false;
      } else if (cv.length > 5000) {
        showError(form, 'comments', t('err_comments_max'));
        ok = false;
      }
    }

    if (!ok) {
      focusFirstInvalid(form);
    }

    return ok;
  }

  function bindForm(form) {
    if (!form) return;
    mergeWdContactFormStringsFromFaqDialog(form);
    if (form.getAttribute('data-wd-cf-bound') === '1') return;
    form.setAttribute('data-wd-cf-bound', '1');
    form.setAttribute('novalidate', '');
    wireNameFieldGuards(form);
    wirePhoneFieldGuards(form);
    form.addEventListener(
      'submit',
      function (e) {
        if (!validate(form)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
  }

  /** @param {ParentNode} [root] */
  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.wd-contact-form form.wd-contact-form__form').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('wd:contact-form-init', function (ev) {
    var r = ev && ev.detail && ev.detail.root;
    init(r || document);
  });
})();
